/*
 * @Description: 
 * @Author: ywj
 * @Date: 2024-11-15 11:46:50
 * @LastEditTime: 2024-11-15 11:47:03
 * @LastEditors: ywj@originqc.com
 */
import { useState, useEffect } from 'react';

const useBackToTop = (threshold = 300) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > threshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return { isVisible, scrollToTop };
};

export default useBackToTop;